import { Button } from '@scuf/common';
import { HttpResponse } from 'axios-http';
import { PartnerKeyModel, PartnersModel, PartnerUserModel } from 'models/spareParts';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { companyAtom, modulesAtom } from 'resources';
import { addModuleToUser, getAvailableModules, removeModuleFromUser } from 'resources/api/';
import { GenericSelector } from '.';
type Props = {
    customer: PartnerUserModel;
};
const ModuleSelector: React.FC<Props> = ({ customer }: Props) => {
    const { t } = useTranslation();
    const setCompanyUser = useSetRecoilState<PartnersModel>(companyAtom);
    const modules = useRecoilValue(modulesAtom);
    const [user, setUser] = useState({ ...customer });
    const handleAction = async (action: 'Add' | 'Remove', item: number): Promise<HttpResponse> => {
        const module = modules.find((e: PartnerKeyModel) => e.Id === item);
        const newModules =
            action === 'Remove' ? [...user.Modules].filter(e => e.Id !== item) : module && [...user.Modules, module];
        const resp =
            action === 'Add'
                ? await addModuleToUser({ Id: customer.Id, ModulesToAdd: [item] })
                : await removeModuleFromUser({ Id: customer.Id, ModulesToAdd: [item] });
        if (!resp.error) setUser(old => ({ ...old, Modules: newModules ?? [] }));
        return resp;
    };
    useEffect(() => {
        setCompanyUser(old => ({ ...old, Users: [...(old.Users ?? [])].map(e => (e.Id === user.Id ? user : e)) }));
    }, [user]);
    return (
        <>
            {(modules && (
                <GenericSelector
                    options={modules}
                    handleSelect={(item: number) => handleAction('Add', item)}
                    customerItems={user.Modules}
                    handleRemove={(item: number) => handleAction('Remove', item)}
                />
            )) || (
                <div>
                    <h4>{t('common:status.Error')}</h4>
                    <Button onClick={async () => await getAvailableModules()}>{t('common:actions.TryAgain')}</Button>
                </div>
            )}
        </>
    );
};

export default ModuleSelector;
